<div *ngIf="data.isLoading">
	<div mat-dialog-content>
		<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
	</div>
</div>
<div *ngIf="!data.isLoading">
	<h1 mat-dialog-title>Descarga de reporte</h1>
	<div mat-dialog-content>{{data.message}}</div>
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close>{{data.success}}</button>
	</div>
</div>
